module.exports = __webpack_public_path__ + "img/basket.87c43fd8.jpg";